export const isFinalizedEvaluationRow = (row = {}) =>
  Number(row?.eval_status) >= 20 ||
  Number(row?.improve_status) >= 20 ||
  Boolean(row?.improve_after && row?.comp_date);

export const isPendingImprovement = (row = {}) =>
  Boolean(
    (Number(row?.direct_risk_score) > 0 || (row?.frequency_id && row?.importancy_id)) &&
    !isFinalizedEvaluationRow(row) &&
    (Number(row?.requires_improve) === 1 || row?.improve_id || row?.improve_plan)
  );

export const getPendingImprovements = (rows) =>
  Array.isArray(rows) ? rows.filter(isPendingImprovement) : [];
